import React from "react";
import { NewSelect, Button } from "components/atomes";

const Tutoring = ({ values, setValues, setForm }) => {
  return (
    <>
      <h3>سجل في الدروس الخصوصية</h3>
      <div className="card--signUp">
        <h4>الحصة: ساعة و نصف</h4>
        <h4>السعر: 2500دج شهريا (بمعدل 4 حصص)</h4>
        <h4>اليوم</h4>
        <NewSelect
          name="day"
          value={values.day}
          options={["حدد اليوم", "السبت"]}
          setValue={setValues}
        />
        <h4>الوقت</h4>
        <NewSelect
          name="time"
          value={values.time}
          options={[
            "حدد الوقت",
            "9:30 - 11:00",
            // "11:00 - 12:30",
            // "14:30 - 16:00",
          ]}
          setValue={setValues}
        />
        <h4> تبدأ الحصص من 4 أكتوبر 2024</h4>
        <Button
          isDisabled={values.day === "" || values.time === ""}
          type="primary"
          handelClick={() => setForm("info")}
        >
          التسجيل قي الدروس الخصوصية
        </Button>
        <Button type="warning" handelClick={() => setForm("info")}>
          لاحقا
        </Button>
      </div>
    </>
  );
};

export default Tutoring;
